import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun, toJS } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../Form';

@inject('folderStore', 'stationStore')
@observer
class FolderStationAdd extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  static propTypes = {
    route: PropTypes.object.isRequired,
  };

  @observable station = {
    name: '',
    description: '',
    folder_id: this.props.params.id,
    identifier: '',
  };
  @observable folder = {
    name: '',
  };

  slug = '/folder';
  title = 'Add Station';

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
  }

  dispose;

  componentWillMount() {
    const { folderStore, params: { id } } = this.props;
    if (id) {
      folderStore.fetchItem(id);
    }
    this.init(id);
  }

  componentWillUnmount() { this.dispose(); }

  @action init(id) {
    const { folderStore } = this.props;
    if (id) { this.station.folder_id = id; }
    this.dispose = action(autorun(() => {
      this.folder = folderStore.findById(id);
    }));
  }

  @action onChangeName = (e) => { this.station.name = e.target.value; }
  @action onChangeDescription = (e) => { this.station.description = e.target.value; }
  @action onChangeIdentifier = (e) => { this.station.identifier = e.target.value; }

  handleSave(e) {
    e.preventDefault();
    const { notify } = this.context;
    const { stationStore, folderStore, params: { id } } = this.props;
    stationStore.createItem(this.station)
      .then(action((station) => {
        console.log(station)
        folderStore.updateStation(Object.assign({}, station.asJson), id);
        notify.success();
        this.context.router.push(this.slug);
      }))
      .catch(action(err => {
        notify.error(err);
      }));
  }

  render() {
    const { stationStore } = this.props;

    if (stationStore.isLoading) { return <Spinner />; }
    const projectName = (this.folder && this.folder.name) || '';

    return (
      <Modal title={this.title} slug={this.slug} isSaving={stationStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput
              label={'Station Name'}
              value={this.station.name}
              onChange={this.onChangeName}
            />
            <TextInput
              label={'Identifier'}
              value={this.station.identifier}
              onChange={this.onChangeIdentifier}
            />
            <TextInput
              label={'Project'}
              value={projectName}
              readOnly
            />
            <TextInput
              label={'Description'}
              value={this.station.description}
              onChange={this.onChangeDescription}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default FolderStationAdd;



// WEBPACK FOOTER //
// ./src/components/Folder/FolderStationAdd.js